<div class="body-container">
  <div class="body-content">
    @if (loading) {
      <div class="loading-container">
        <div class="loading-div">
          <mat-spinner diameter="20" value="80"></mat-spinner>
          <span>{{'common.loading' | translate}}...</span>
        </div>
      </div>
    }
    <mat-sidenav-container autosize>
      <mat-sidenav
        #drawer
        mode="over"
        position="end"
        (closed)="onSidebarClose()"
        [opened]="openSidebar"
        position="end"
        disableClose="false"
        >
        <div class="side-nav-body">
          <div class="align-right">
            <button style="font-size:18px;" class="mt-3 mr-2 float-right" [title]="'common.close' | translate" attr.aria-label="{{'aria.close_side_menu' | translate}}" mat-icon-button (click)="openSidebar = false">
              <i class="fas fa-times"></i>
            </button>
            <router-outlet
              name="sidebar"
              (activate)="onRouterOutletActivate()"
              (deactivate)="onRouterOutletDeactivate()"
              >
            </router-outlet>
          </div>
        </div>
      </mat-sidenav>
      <mat-sidenav #drawermenu mode="over" position="start">
        <app-sidebar-menu (closeDrawer)="drawer.toggle()"></app-sidebar-menu>
      </mat-sidenav>
      <div class="webcontainer">
        <header id="header">

          @if (siteType !== 'production') {
<div class="small-div site-type-container" style="
              
          ">
              @if (siteType==='demo') {
                <span>Demo Site</span>
              }
              @if (siteType==='uat') {
                <span>UAT Site</span>
              }
              @if (siteType==='dev') {
                <span>Local Dev Site</span>
              }
            </div>
          }
          <!--App Switcher Button-->
          @if (authService.hasAdminRole()) {
            <button [title]="'theme_base.switch_to_admin' | translate" mat-button
              (click)="switchToAdminSite()" class="d-none d-md-block text-btn">
              {{'theme_base.switch_to_admin' | translate}}
            </button>
          }

          @if (authService.hasAdminRole()) {
            <button class="d-block d-md-none" [title]="'aria.show_donor_campaigns' | translate" attr.aria-label="{{'theme_base.switch_to_admin' | translate}}" (click)="switchToAdminSite()" mat-icon-button>
              <i class="far fas fa-random btn-header-icon"></i>
            </button>
          }

          @if (showCampaignSwitcher$ | async) {
            <button [title]="'aria.show_donor_campaigns' | translate" attr.aria-label="{{'aria.show_donor_campaigns' | translate}}" (click)="onChangeCampaign()" mat-icon-button>
              <i class="far fa-home btn-header-icon"></i>
            </button>
          }
          @if (showLangSwitcher) {
            <button [title]="'aria.lang' | translate" attr.aria-label="{{ 'aria.lang' | translate }}" mat-button class="text-btn" (click)="changeLanguage($event)">
              {{"header.lang" | translate}}
            </button>
          }
          <button [title]="'aria.view_helpdesk' | translate" attr.aria-label="{{'aria.view_helpdesk' | translate}}" mat-icon-button [uwRouterLink]="['/info', 'help-desk']">
            <i class="far fa-solid fa-headset header-option"></i>
          </button>

          <button [title]="'aria.view_faq' | translate" attr.aria-label="{{'aria.view_faq' | translate}}" mat-icon-button [uwRouterLink]="['/info', 'faq']">
            <i class="far fa-question-circle header-option"></i>
          </button>
          <!-- <button
          aria-label='help button'
          aria-label='sidemenu button'
          mat-icon-button
          >
          <i class="far fa-question-circle"></i>
        </button> -->
        @if (authService.userLoggedIn$ | async; as loggedInMetadata) {
          @if (loggedInMetadata.loggedIn) {
            <button [title]="'aria.view_profile' | translate" attr.aria-label="{{'aria.view_profile' | translate}}" (click)="onSideMenuClick()" mat-icon-button>
              <i class="far fa-user-circle btn-header-icon"></i>
            </button>
          }
          @if (!loggedInMetadata.loggedIn) {
            <button [title]="'aria.sign_in' | translate" attr.aria-label="{{'aria.sign_in' | translate}}" mat-icon-button
              (click)="onSignInClick()">
              <i class="far fa-sign-in header-option"></i>
            </button>
          }
        }

      </header>
      <header  id="subheader" [ngClass]="{'extendSubMenu': (this.hideOnlyRightNav$ | async) }">
        @if ((this.showCampaignSpecificLogos$ | async)) {
          <div class="logo">
            @if (this.mainHeaderLogo$ | async; as MainLogoUrl;) {
              <img alt="{{mainHeaderLogoAlt$ | async}}"  src="{{ MainLogoUrl }}" />
            }
            <!-- <ng-container  *ngIf="this.mainHeaderLogo$ | async as MainLogoUrl; else defaultLogo">
            <img alt="{{mainHeaderLogoAlt$ | async}}"  src="{{ MainLogoUrl }}" />
          </ng-container>
          <ng-template #defaultLogo>
            <img *ngIf="currentLanguage=='en'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-en.svg" />
            <img *ngIf="currentLanguage=='fr'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-fr.svg" />
          </ng-template> -->
        </div>
      }

      @if ((this.showCampaignSpecificLogos$ | async) && this.mainHeaderLogo2$ | async; as MainLogoUrl2;) {
        <div  class="logo align-right">
          <img alt="{{mainHeaderLogo2Alt$ | async}}"  src="{{ MainLogoUrl2 }}" />
          <!-- <ng-container  *ngIf="MainLogoUrl2.displayLogo2">
          <img alt="{{mainHeaderLogo2Alt$ | async}}"  src="{{MainLogoUrl2.logo2}}" />
        </ng-container>
        <ng-container *ngIf="MainLogoUrl2.displayDefaultLogo">
          <img *ngIf="currentLanguage=='en'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-en.svg" />
          <img *ngIf="currentLanguage=='fr'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-fr.svg" />
        </ng-container> -->
      </div>
    }

    <!-- <div  class="logo align-right" *ngIf="!this.hideNav && this.mainHeaderLogo2$ | async as MainLogoUrl2;">
    <img alt="{{mainHeaderLogo2Alt$ | async}}"  src="{{MainLogoUrl2}}" />
  </div> -->
  <!--temporary disable toggler until more menu require-->
  @if (false) {
    <button [title]="'aria.show_hide_menu' | translate"
      id="sidemenu-btn"
      mat-icon-button
      (click)="drawermenu.toggle()"
      >
      <i class="fas fa-bars"></i>
    </button>
  }
</header>
@if ((this.hideOnlyRightNav$ | async) === false) {
  <nav>
    <div class="top-menu">
      <!-- <h1 *ngIf="showMyCampaignLink$ | async" class="px-4 mb-3">
      <a style="cursor: pointer; color:white" [uwRouterLink]="['/donor', campaignGuid,'my-campaign']">
        {{"my_campaign.title" | translate}}
      </a>
    </h1> -->
  </div>
</nav>
}
<main>
  <div class="content">
    <!-- <div class="my-campaign-link-container px-4 py-2" *ngIf="!(this.hideOnlyRightNav$ | async)">
    <h1 class="mb-0" *ngIf="showMyCampaignLink$ | async">
      <a style="cursor: pointer; color:#fff" [uwRouterLink]="['/donor', campaignGuid,'my-campaign']">
        {{"my_campaign.title" | translate}}
      </a>
    </h1>
  </div> -->

  <router-outlet ></router-outlet>
</div>
</main>
<footer>

  <div>
    <a [uwRouterLink]="['/info', 'faq']">{{ "theme_base.faqs" | translate }}</a> |
    <a [uwRouterLink]="['/info', 'help-desk']">{{ "theme_base.help" | translate }}</a> |
    <a [uwRouterLink]="['/info', 'privacy-policy']">{{ "theme_base.privacy_policy" | translate }}</a>
  </div>
  <!-- <div [innerHtml]="this.footerLinks$ | async"> </div> -->
  <div [innerHtml]="this.footerCopyrights$ | async">
  </div>
</footer>
</div>
</mat-sidenav-container>
<router-outlet name="profile-display"></router-outlet>
</div>
</div>
<!-- <router-outlet></router-outlet> -->
